import { render, staticRenderFns } from "./AttachFile.vue?vue&type=template&id=e8e0c6ae&scoped=true"
import script from "./AttachFile.vue?vue&type=script&lang=js"
export * from "./AttachFile.vue?vue&type=script&lang=js"
import style0 from "./AttachFile.vue?vue&type=style&index=0&id=e8e0c6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e0c6ae",
  null
  
)

export default component.exports